var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"问题详情","width":_vm.width,"visible":_vm.issueShow,"modal-append-to-body":false,"append-to-body":false,"top":_vm.top,"modal":_vm.modal,"cancel-on-click-modal":false},on:{"close":function($event){return _vm.$emit("update:issueShow", false)}}},[_c('CustomDetail',{attrs:{"issueId":_vm.issueId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }